var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.92857 14.7143H2.64286C2.01167 14.7143 1.5 14.2026 1.5 13.5714V9C1.5 8.36882 2.01167 7.85714 2.64286 7.85714H16.3571C16.9883 7.85714 17.5 8.36882 17.5 9V13.5714C17.5 14.2026 16.9883 14.7143 16.3571 14.7143H14.0714M4.92857 7.85714V2.14286C4.92857 1.51167 5.44025 1 6.07143 1H12.9286C13.5598 1 14.0714 1.51167 14.0714 2.14286V7.85714M4.92857 12.4286H14.0714V17H4.92857V12.4286Z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.0c2e9b39d26f75be2320407decea2a4f.svg";
export { ForwardRef as ReactComponent };